import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./style.scss";

const RangeOptionSelect = ({
  defaultOption,
  options = [],
  unit,
  onClick = () => {}
}) => {
  const [selectedOption, setSelectedOption] = useState(
    defaultOption || options[0]
  );

  const handleOptionClick = option => {
    setSelectedOption(option);
    onClick(option);
  };

  return (
    <div className="range-option-select">
      <div className="fade-out" />
      <div className="options">
        {options.map(({ id, value, description }) => (
          <div
            key={value}
            className="option"
            onClick={() => handleOptionClick({ id, value, description })}
          >
            <div
              className={classNames("value", {
                active: value === selectedOption.value
              })}
            >
              {value}
            </div>
            <div className="description">{description}</div>
          </div>
        ))}
        {unit && <div className="unit">{unit}</div>}
      </div>
    </div>
  );
};

RangeOptionSelect.propTypes = {
  defaultOption: PropTypes.shape({
    value: PropTypes.string,
    description: PropTypes.string
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      description: PropTypes.string
    })
  ),
  unit: PropTypes.string,
  onClick: PropTypes.func
};

export default RangeOptionSelect;
